import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-p2-client-update-edit',
  templateUrl: './p2-client-update-edit.component.html',
  styleUrls: ['./p2-client-update-edit.component.css']
})
export class P2ClientUpdateEditComponent implements OnInit {
    clientUpdateId;

    public edit?: Edit;

    public refreshing = false;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.clientUpdateId = this.stateService.getStateParams()['clientupdate_id'];
    }

    private async loadEdit() {
        if (!!this.clientUpdateId) {
            this.edit = (await this.datatask.Post(146, { clientupdate_id: this.clientUpdateId }))[0];
        }
    }

    public async refreshChanges() {
        try {
            this.refreshing = true;

            await this.loadEdit();
        } finally {
            this.refreshing = false;
        }
    }

    private async init() {
        this.loadEdit();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    clientupdate_id: string;
    remarks_id: string;
    pst: string;
    p2_clientupdate_status: string;
    step: string;
    steps: string;
    reg_datetime: string;
    last_statement: string;
}
